// extracted by mini-css-extract-plugin
export var box = "_4f-0";
export var check = "_4f-1";
export var checkboxButton = "_4f-6";
export var checkboxGroup = "_4f-5";
export var disabled = "_4f-7";
export var ghost = "_4f-9";
export var input = "_4f-2";
export var label = "_4f-4";
export var normal = "_4f-8";
export var uncheck = "_4f-3";